import React from 'react';
import PropTypes from 'prop-types';

import Market from 'newDesign/modules/live/components/bettingSuggestions/Market';

const hasMarketData = m => Boolean(
  m
    && m.marketName
    && Array.isArray(m.outcomes)
    && m.outcomes.length,
);

const BSOdds = ({ usedMarket, usedMarket2 }) => {
  const hasSecondMarket = hasMarketData(usedMarket2);

  return (
    <div className='mt-[2.1vw] grid grid-cols-2 text-center'>
      {/* First / single market */}
      <div
        className={
          hasSecondMarket
            ? ''
            : 'col-span-2 flex justify-center'
        }
      >
        <div
          className={
            hasSecondMarket
              ? ''
              : 'w-[65%]'
          }
        >
          <Market
            key={
              usedMarket && usedMarket.marketName
                ? usedMarket.marketName
                : 'm1'
            }
            {...usedMarket}
          />
        </div>
      </div>

      {/* Second market (normal column width) */}
      {hasSecondMarket ? (
        <Market
          key={
            usedMarket2 && usedMarket2.marketName
              ? usedMarket2.marketName
              : 'm2'
          }
          {...usedMarket2}
        />
      ) : null}
    </div>
  );
};

BSOdds.propTypes = {
  usedMarket: PropTypes.object,
  usedMarket2: PropTypes.object,
};

BSOdds.defaultProps = {
  usedMarket: null,
  usedMarket2: null,
};

export default BSOdds;
